import { createEffect, ofType, Actions } from "@ngrx/effects";
import {
  withLatestFrom,
  switchMap,
  map,
  catchError
} from "rxjs/operators";
import { Store } from "@ngrx/store";
import { DaveActions } from "../actions/actions";
import { HttpService } from "../../services/http.service";
import { State } from "../index";
import { StatusFromSVActionTypes } from "../actions/statusFromSV.actions";
import { StatusFromSVEntityFromBackend } from "../../entities/statusFromSV.entity";
import { BaseActionTypes } from "../actions/base.actions";
import { of } from "rxjs";
import { Injectable } from "@angular/core";

enum ErrorCodes {
  Load = "Status Abrufen fehlgeschlagen",
  Modify = "Status Bearbeiten fehlgeschlagen"
}

@Injectable()
export class StatusFromSVEffects {

  LoadStatusFromSV = createEffect(() => this.actions$.pipe(
    ofType(StatusFromSVActionTypes.GetStatusFromSVRequest),
    withLatestFrom(this.store$),
    switchMap(([action, store]) => {
      const queryString = `
    query{
    statusfromsv{
      id
      name
      partnerId
    }
    }`
  ;
      return this.gatewayHttpService
        .graphQl({ query: queryString }, { token: store.base.token, retry: true })
        .pipe(
          map(res =>
            res && res.statusfromsv
              ? StatusFromSVActionTypes.UpdateStatusFromSV({
                  Payload: res.statusfromsv.map(val =>
                    StatusFromSVEntityFromBackend(val)
                  )
                })
              : BaseActionTypes.ErrorAction({
                  Payload: { ToasterMessage: ErrorCodes.Load }
                })
          ),
          catchError((err, caught) =>
            of(
              BaseActionTypes.ErrorAction({
                Payload: {
                  ToasterMessage: ErrorCodes.Load,
                  Err: err,
                  Caught: caught
                }
              })
            )
          )
        );
    })
  ));
  constructor(
    private actions$: Actions<DaveActions>,
    private store$: Store<State>,
    private gatewayHttpService: HttpService
  ) {}
}
